import React from "react";

const getMode = (mode) => {
  if (mode === "success") {
    return " border-green-600 dark:border-green-500 dark:focus:border-green-500  focus:border-green-600";
  } else if (mode === "error") {
    return "dark:border-red-500 border-red-600 dark:focus:border-red-500 focus:border-red-600";
  } else {
    return "dark:border-gray-600 dark:focus:border-blue-500 border-gray-300 focus:border-blue-600";
  }
};

const getLable = (content, mode, id) => {
  if (mode === "success") {
    return (
      <label
        htmlFor="first_name"
        className="block text-sm mb-2 font-medium  px-2.5 text-green-600 dark:text-green-400"
      >
        {content}
      </label>
    );
  } else if (mode === "error") {
    return (
      <label
        htmlFor={id}
        className="block text-sm text-red-600 dark:text-red-500 mb-2 font-medium  px-2.5"
      >
        {content}
      </label>
    );
  } else {
    return (
      <label
        htmlFor="first_name"
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white px-2.5 "
      >
        {content}
      </label>
    );
  }
};

const getExtraText = (content, mode, id) => {
  if (mode === "success") {
    return (
      <p id={id} className="mt-2 text-xs text-green-600 dark:text-green-400">
        {content}
      </p>
    );
  } else if (mode === "error") {
    return (
      <p id={id} className="mt-2 text-xs text-red-600 dark:text-red-400">
        {content}
      </p>
    );
  } else {
    return (
      <p id={id} className="mt-2 text-xs text-gray-900 dark:text-white">
        {content}
      </p>
    );
  }
};

const Input = (props) => {
  return (
    <>
      <div className={props.padding}>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none dark:text-lightPrimary text-darkPrimary">
            {props.icon}
          </div>
          {getLable(props.placeHolder, props.mode, props.id)}
          {props.isDate === "date" ? (
            <input
              dir={props.dir === "ltr" ? "ltr" : "rtl"}
              ref={props.refrence}
              type={props.type}
              id={props.id ? props.id : "input_" + Math.random()}
              value={props.value}
              onChange={props.handler}
              accept={props.accept}
              disabled={props.disabled ? props.disabled : false}
              className={`block px-2.5 pb-2.5 pt-4 text-sm lightTextPrimary appearance-none w-full
            dark:text-darkTextPrimary 
            dark:bg-darkPrimary bg-lightPrimary 
            shadow-md border 
            focus:outline-none focus:ring-0 peer
            ${props.rounded === undefined ? "rounded-lg" : props.rounded}
            ${getMode(props.mode)}
            ${props.extraClass}`}
              // placeholder={props.placeHolder}
              {...props}
            />
          ) : (
            <input
              dir={props.dir === "ltr" ? "ltr" : "rtl"}
              ref={props.refrence}
              type={props.type}
              inputMode={props.inputMode === undefined ? "" : props.inputMode}
              maxLength={props.maxLength === undefined ? "" : props.maxLength}
              id={props.id ? props.id : "input_" + Math.random()}
              value={props.value}
              onChange={props.handler}
              disabled={props.disabled ? props.disabled : false}
              className={`block text-sm lightTextPrimary appearance-none w-full
            dark:text-darkTextPrimary 
            dark:bg-darkPrimary bg-lightPrimary 
            shadow-md border 
            focus:outline-none focus:ring-0 peer
            ${props.type === "file" ? "p-0.5" : "px-2.5 pb-2.5 pt-4"}
            ${props.rounded === undefined ? "rounded-lg" : props.rounded}
            ${getMode(props.mode)}
            ${props.extraClass}`}
              // placeholder={props.placeHolder}
            />
          )}
        </div>
        {getExtraText(props.message, props.mode, props.id)}
      </div>
    </>
  );
};

export default Input;
